import { render } from "./Pauze.vue?vue&type=template&id=d58bec96&scoped=true"
import script from "./Pauze.vue?vue&type=script&lang=js"
export * from "./Pauze.vue?vue&type=script&lang=js"

import "./Pauze.vue?vue&type=style&index=0&id=d58bec96&lang=scss&scoped=true"

import exportComponent from "C:\\websites\\kroechkwis-dielnimmer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d58bec96"]])

export default __exports__